import { ClientProfile } from '@deqo/podopolis';
import { Client } from './Client';
import { Pod } from './ClientSymbols';

export type SelfProfileMutator = (profile: ClientProfile) => void;

export class Self extends Client {

    public get self() {
        return true;
    }

    public delete(...keys: string[]) {
        this.patch(Object.fromEntries(keys.map(x => [x, null])));
    }

    public patch(values: Record<string, any>) {
        this[Pod].patchProfile(values);
    }
}

